import React from 'react'
import { pathOr } from 'ramda'

// eslint-disable-next-line
const data = JSON.parse(window.__initialData__)
const contact = pathOr('', ['pages', 'contact'], data)
const bio = pathOr('', ['pages', 'bio'], data)

const getHtml = (__html) => ({ __html })

const Contact = () => (
  <div className="contact static">
    <div className="contact content" dangerouslySetInnerHTML={getHtml(contact)} />
    <div className="biography content" dangerouslySetInnerHTML={getHtml(bio)} />
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js